import { render, staticRenderFns } from "./TenancyDocuments.vue?vue&type=template&id=0d3d224a&scoped=true&"
import script from "./TenancyDocuments.vue?vue&type=script&lang=js&"
export * from "./TenancyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDocuments.vue?vue&type=style&index=0&id=0d3d224a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3d224a",
  null
  
)

export default component.exports